import SentralPortalModal from "./SentralPortalModal";
export default SentralPortalModal;
